import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import React from "react";

import TaskToolTip from "./taskToolTip";
import HelperText from "../../../../../../components/feedback/helper-text/";
import { formatCamundaDateTaskField } from "../../../../../../util/dateUtils";
import { taskFieldInputShortDateFormat } from "../../../constants/formats";
import { getUnitPropertie } from "../../functions";
import { shouldDisableField } from "../util/shouldDisableField";

function TaskFieldInput(props) {
  const {
    showValidate,
    error,
    value,
    readOnly,
    className,
    toolTip,
    multiLine,
    rows,
    style,
    id,
    fullWidth,
    fieldProperties,
    component,
    isPreview,
  } = props;

  const { form } = props;

  const waitVariables = getUnitPropertie(fieldProperties, "waitVariables");
  const waitVariablesOptions = getUnitPropertie(
    fieldProperties,
    "waitVariablesOptions",
  );

  let errorComponent = error;
  let showValidateComponent = showValidate;
  const hidden = getUnitPropertie(fieldProperties, "hidden");
  const maxLength = getUnitPropertie(fieldProperties, "maxLength");
  const regex = getUnitPropertie(fieldProperties, "regex");
  const label = getUnitPropertie(fieldProperties, "label");
  const isRequired = getUnitPropertie(fieldProperties, "isRequired");

  const isFieldDisabled = shouldDisableField(
    waitVariables,
    waitVariablesOptions,
    form,
  );

  const type =
    hidden === true
      ? "hidden"
      : fieldProperties &&
        fieldProperties.type &&
        (fieldProperties.type.name || fieldProperties.type);

  const typeLowerCase =
    (fieldProperties.type &&
      ((fieldProperties.type.name &&
        fieldProperties.type.name.toLowerCase &&
        fieldProperties.type.name.toLowerCase()) ||
        fieldProperties.type.toLowerCase())) ||
    "text";

  let formatedValue = value;

  // try to parse date to YYYY-MM-DD
  if (value && typeLowerCase === "date") {
    formatedValue = formatCamundaDateTaskField(value);
  }

  formatedValue = formatedValue === null || !formatedValue ? "" : formatedValue;

  if (isPreview && formatedValue.length > 0) {
    const re = new RegExp(regex);
    if (re.test(formatedValue)) {
      errorComponent = undefined;
      showValidateComponent = false;
    } else {
      errorComponent = getUnitPropertie(fieldProperties, "messageRegex");
      showValidateComponent = true;
    }
  }

  const inputProps = maxLength && { maxlength: maxLength };

  function handleOnChange(event) {
    const { onChange, fieldProperties } = props;

    const upperCase = getUnitPropertie(fieldProperties, "upperCase");

    const value = event.target.value;

    // em alguns casos "type" vem como objeto
    const typeLowerCase =
      (fieldProperties.type &&
        ((fieldProperties.type.name &&
          fieldProperties.type.name.toLowerCase &&
          fieldProperties.type.name.toLowerCase()) ||
          fieldProperties.type.toLowerCase())) ||
      "text";

    const dictionaryTypes =
      typeLowerCase === "date"
        ? {
            date: {
              type: "Date",
              value: moment(value).format(taskFieldInputShortDateFormat),
              valueInfo: {},
            },
          }
        : {};

    const camundaValue = dictionaryTypes[typeLowerCase];

    let formatedValue =
      typeLowerCase === "date" ? formatCamundaDateTaskField(value) : value;

    formatedValue = upperCase ? formatedValue.toUpperCase() : formatedValue;

    if (typeLowerCase === "text") {
      const regexDay = /@Dia/g;
      const regexUserName = /@NomeUsuario/g;
      formatedValue = formatedValue
        .replaceAll(regexDay, new Date().toLocaleString())
        .replaceAll(regexUserName, props?.auth?.login?.name);
    }

    onChange && onChange(fieldProperties.id, formatedValue, camundaValue);
  }

  function handleOnBlur(event) {
    const { fieldProperties, OnBlur } = props;

    OnBlur && OnBlur(fieldProperties.id, event.target.value, fieldProperties);
  }

  return (
    <TaskToolTip title={toolTip || ""}>
      <FormControl
        key={"divPadrao" + id}
        margin="normal"
        {...(fullWidth ? { fullWidth } : {})}
      >
        <InputLabel htmlFor={label} shrink required={isRequired}>
          {label}
        </InputLabel>

        {showValidateComponent && errorComponent ? (
          <Input
            value={formatedValue}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            error={!!errorComponent}
            readOnly={readOnly}
            className={className}
            multiline={multiLine}
            rows={rows}
            type={type}
            style={style}
            id={id}
            color={component && fieldProperties.color}
            inputProps={inputProps}
            disabled={isFieldDisabled}
          />
        ) : (
          <Input
            value={formatedValue}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            error={undefined}
            readOnly={readOnly}
            className={className}
            multiline={multiLine}
            rows={rows}
            type={type}
            style={style}
            id={id}
            color={component && fieldProperties.color}
            inputProps={inputProps}
            disabled={isFieldDisabled}
          />
        )}

        {showValidateComponent && errorComponent && (
          <HelperText>{errorComponent}</HelperText>
        )}
      </FormControl>
    </TaskToolTip>
  );
}

export default TaskFieldInput;
